import Button from "@amzn/meridian/esm/components/button";
import Row from "@amzn/meridian/esm/components/row";
import Tag from "@amzn/meridian/esm/components/tag";
import Theme from "@amzn/meridian/esm/components/theme";
import {
  EXTERNAL_PARTICIPANTS_LABEL,
  EXTERNAL_PARTICIPANTS_VALUE,
} from "./whosWho.constants";
import { formatWhosWhoCountLabel } from "./whosWho.utils";

const CHIP_BORDER_RADIUS = 13;
const CHIP_HEIGHT = 20;
const CHIP_FONT_SIZE = 12;
const PILL_THEME_TOKENS = {
  buttonBorderRadius: CHIP_BORDER_RADIUS,
  buttonHeightSmall: CHIP_HEIGHT,
  buttonSpacingInsetHorizontalSmall: 0,
  tagLabelFontSize: CHIP_FONT_SIZE,
  tagFontSize: CHIP_FONT_SIZE,
};
const TAG_WITHOUT_INDICATOR_TOKENS = { tagIndicatorDiameter: 0 };

/**
 * Pill presentation for V2 participant filtering.
 */
const WhosWhoOrgPills = ({
  orgs = [],
  orgColorMap,
  externalCount = 0,
  activeFilter,
  onSelect,
}) => {
  if (orgs.length === 0 && externalCount === 0) return null;
  const externalParticipantsLabel = formatWhosWhoCountLabel(
    EXTERNAL_PARTICIPANTS_LABEL,
    externalCount
  );
  const toggle = (value) => {
    onSelect(activeFilter === value ? null : value);
  };

  return (
    <Row spacing="200" wrap="down" alignmentVertical="center">
      <Theme tokens={PILL_THEME_TOKENS}>
        <Button
          type="link"
          onClick={() => onSelect(null)}
          size="small"
        >
          <Theme tokens={TAG_WITHOUT_INDICATOR_TOKENS}>
            <Tag type="neutral">All</Tag>
          </Theme>
        </Button>
        {orgs.map((org) => (
          <Button
            key={org}
            type="link"
            onClick={() => toggle(org)}
            size="small"
          >
            <Theme tokens={{ tagBorderColorStatusNeutral: orgColorMap[org] }}>
              <Tag type="neutral">{org}</Tag>
            </Theme>
          </Button>
        ))}
        {externalCount > 0 && (
          <Button
            type="link"
            onClick={() => toggle(EXTERNAL_PARTICIPANTS_VALUE)}
            size="small"
          >
            <Theme tokens={TAG_WITHOUT_INDICATOR_TOKENS}>
              <Tag type="neutral">
                {externalParticipantsLabel}
              </Tag>
            </Theme>
          </Button>
        )}
      </Theme>
    </Row>
  );
};

export default WhosWhoOrgPills;
